export default class Alumni {
  constructor(npm, tgl_lahir) {
    this.npm = npm;
    this.tgl_lahir = tgl_lahir;
  }
}
